module.exports = __webpack_public_path__ + "img/ex01.a92b7ab7.png";